import {
    RECEIVE_SCHEDULE_MODULE_DATA,
    REQUEST_SCHEDULE_MODULE_DATA,
    SCORE_SCHEDULE_MODULE_DATA
} from '../actions';

function completeScoring(state, action) {
    const buckets = action.buckets || [];
    if (buckets.length === 0) {
        return { ...state, scored: true };
    }
    return { ...state, buckets, scored: true };
}

export default function scheduleModuleReducer(state = {}, action) {
    switch (action.type) {
        case SCORE_SCHEDULE_MODULE_DATA:
            return completeScoring(state, action);
        case RECEIVE_SCHEDULE_MODULE_DATA:
            return {
                ...state,
                name: action.name,
                buckets: action.buckets,
                receivedTime: action.receivedTime
            };
        case REQUEST_SCHEDULE_MODULE_DATA:
            return {
                ...state,
                lang: action.lang,
                query: action.query,
                requestedTime: action.requestedTime,
                scored: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/scheduleModule/reducers/index.js